var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7854 23.7487C18.4923 23.7487 18.1973 23.6778 17.9256 23.5353L13.0251 20.9577L8.07523 23.5344C7.77069 23.6963 7.42664 23.769 7.08264 23.7441C6.73864 23.7192 6.40865 23.5977 6.1306 23.3936C5.85074 23.1922 5.63337 22.9159 5.50348 22.5965C5.37359 22.2771 5.33645 21.9275 5.39633 21.588L6.33233 16.1315L2.35254 12.2199C2.10442 11.9802 1.92896 11.6753 1.84633 11.3404C1.7637 11.0054 1.77726 10.654 1.88543 10.3264C1.99101 9.99826 2.18685 9.70651 2.45053 9.48452C2.71422 9.26254 3.03509 9.1193 3.3764 9.07121L8.85433 8.27507L11.3449 3.28127C11.6587 2.64652 12.2926 2.25293 13.0009 2.25293C13.7092 2.25293 14.343 2.64652 14.6568 3.28127L17.1071 8.24548L22.6254 9.07121C22.9667 9.1193 23.2875 9.26254 23.5512 9.48452C23.8149 9.70651 24.0108 9.99826 24.1163 10.3264C24.2241 10.654 24.2374 11.0054 24.1548 11.3402C24.0722 11.6751 23.897 11.98 23.6492 12.2199L19.6847 16.084L20.6054 21.5889C20.6648 21.9284 20.6274 22.2778 20.4975 22.5971C20.3677 22.9164 20.1506 23.1927 19.8712 23.3945C19.5555 23.6237 19.1756 23.7477 18.7854 23.7487Z",
    fill: "#FF7B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfill);
export default __webpack_public_path__ + "static/media/starfill.69a5f94ee694852867c2fb7af00c54e8.svg";
export { ForwardRef as ReactComponent };